import { sliders } from "./modules/sliders";
import { menu } from "./modules/menu";
import { detectBrowser } from "./modules/detectbrowser";
import { forms } from "./modules/forms";
// import { accordions } from './modules/accordions';

import { misc } from "./modules/misc";
import { privacy } from "./modules/privacy";
import { watchlist } from "./modules/watchlist";
import { share } from "./modules/share";
import { lists } from "./modules/lists";
import { reviews } from "./modules/reviews";
import { googlemaps } from "./modules/googlemaps";
import { masonry } from "./modules/masonry";

$jq3(document).ready(function () {
  detectBrowser();
  sliders();
  forms();
  // accordions();
  misc();
  watchlist();
  share();
  lists();
  reviews();
  masonry();

  function keyboardHandler(e, firstFocus, lastFocus) {
    if (e.keyCode === 9) {
      //Rotate Focus
      if (e.shiftKey && document.activeElement === firstFocus) {
        e.preventDefault();
        firstFocus.focus();
      } else if (!e.shiftKey && document.activeElement === lastFocus) {
        e.preventDefault();
        firstFocus.focus();
      }
    }
  }

  const navigation = document.querySelector(".menu__container");
  if (navigation) {
    const navigationLinks = navigation.querySelectorAll(
      'a:not([tabindex="-1"], [type="hidden"])',
    );
    const navigationFirst = navigationLinks[0];
    const navigationLast = navigationLinks[navigationLinks.length - 1];

    navigation.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") {
        keyboardHandler(e, navigationFirst, navigationLast);
      }
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.keyCode === 9) {
      if (
        e.target.closest(".menu__container") ||
        e.target.classList?.contains("hamburger")
      ) {
        return;
      }
      window.globalLastFocus = e.target;
    }

    if (e.key === "Escape") {
      $jq3(".hamburger").removeClass("is-active");
      $jq3(".menu__container").removeClass("menu__container--is-active");
      $jq3(".menu__overlay").removeClass("menu__overlay--is-active");
      $jq3(".menu__item").removeClass("menu__item--is-open");
      $jq3(".menu__container").removeClass("menu__container--submenu-open");

      window.globalLastFocus.focus();
    }
  });

  // jplist.init();
  new WOW({
    offset: 100,
  }).init();

  window.googlemaps = googlemaps();

  if (localStorage.getItem("consent") !== null) {
    // googlemaps();
  }

  $jq3(".allow-maps-button").on("click", function (e) {
    e.preventDefault();

    localStorage.setItem("consent", true);

    // googlemaps();
  });

  $jq3(".privacy-button").on("click", function (e) {
    e.preventDefault();

    privacy();
  });

  menu();
});
